export const FAVOURITE_ONBOARDING_STEPS = {
  FINISH: 'finish_favourite_onboarding',
};
